export default __webpack_public_path__ + "static/qrright-0dc8fe2a93b7e3d4be429a2964bd8ee8.png";